module.exports = __webpack_public_path__ + "img/EE12541563.1ba4a87e.png";